<template>
    <KDialog
        v-model:open="open"
        :title="definition.title"
        width="lg"
    >
        <!-- The dialog header already shows the title; success closes
             the dialog like the previous embedded renderer did. -->
        <StoryblokForm
            :key="schemaKey"
            hide-title
            :definition="definition"
            :form-id="formId"
            :send="sendRequest"
            @submitted="trackSubmitted"
            @submit-error="capture('lead_submit_error', trackingProperties)"
        />
    </KDialog>
</template>

<script setup>
// This wrapper exists purely as a code-splitting boundary. KDialog and
// StoryblokForm together pull the date-picker and TanStack Form graph
// (~62 KB transfer), which article-cta only ever needs after a click.
import { KDialog } from '@vemedia/karibu'
import StoryblokForm from '~/components/storyblok-form/storyblok-form.vue'
import { sendRequest } from '~/utils/forms'

const props = defineProps({
    definition: {
        type: Object,
        required: true,
    },
    formId: {
        type: String,
        required: true,
    },
})

const emit = defineEmits(['submitted'])
const { capture } = useTracking()
const trackingProperties = { form: 'storyblok-form', form_id: props.formId, surface: 'article-cta' }

function trackSubmitted() {
    capture('lead_submitted', trackingProperties)
    emit('submitted')
}

const open = defineModel('open', {
    type: Boolean,
    default: false,
})

// The normalized schema is immutable for one renderer mount; remount when the field
// definitions change so TanStack gets a fresh default-value shape.
const schemaKey = computed(() => JSON.stringify(props.definition?.fields ?? []))
</script>
